import { Box, Stack, Typography } from '@mui/material';

const getColor = (disabled: boolean, active: boolean): string => {
	if (disabled) {
		return 'text.disabled';
	}
	return active ? 'text.interactive' : 'text.secondary';
};

export const TabLabelText = ({
	label,
	subLabel,
	active = false,
	disabled = false,
}: {
	label: string;
	subLabel?: string;
	active?: boolean;
	disabled?: boolean;
}) => {
	return (
		<Stack pl={1}>
			<Typography color={getColor(disabled, active)} sx={{ textAlign: 'left', textTransform: 'none' }}>
				{label}
			</Typography>
			<Typography sx={{ textTransform: 'none', textAlign: 'left' }} variant="caption">
				{subLabel}
			</Typography>
		</Stack>
	);
};

export const NodeIndexIndicator = ({ index, active = false }: { index: number; active?: boolean }) => {
	return (
		<Box
			sx={{
				backgroundColor: active ? 'secondary.main' : 'neutrals.disabled',
				color: '#FFF',
				padding: '.375rem .525rem',
				borderRadius: '1rem',
				height: '1.5rem',
				width: '1.5rem',
			}}
		>
			{index}
		</Box>
	);
};
